import {
  ChangeDetectorRef,
  InjectionToken,
  Pipe,
  PipeTransform,
  inject,
} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'number',
  standalone: true,
  pure: false,
})
export class NumberPipe implements PipeTransform {
  constructor(private translate: TranslateService, _ref: ChangeDetectorRef) {}
  transform(
    value: string | number | null | undefined,
    config: Partial<{
      lang: string;
      maximumFractionDigits: number;
      maximumSignificantDigits?: number;
    }> = { maximumFractionDigits: 2 }
  ): string {
    const numericValue = Number(value);
    if (value === null || value === undefined || Number.isNaN(numericValue)) {
      return '';
    }
    return new Intl.NumberFormat(config.lang || this.translate.currentLang, {
      maximumFractionDigits: config.maximumFractionDigits,
      maximumSignificantDigits: config.maximumSignificantDigits,
      useGrouping: false,
    }).format(numericValue);
  }
}
